// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

// Import and register Stimulus Components
import Sortable from "@stimulus-components/sortable"
import Dialog from "@stimulus-components/dialog"

// Import custom controllers
import ConditionalSortableController from "./conditional_sortable_controller"

// Register the sortable controller
application.register("sortable", Sortable)
application.register("dialog", Dialog)
application.register("conditional-sortable", ConditionalSortableController)

// Import and register all other controllers manually
import HelloController from "./hello_controller"
import NotificationsController from "./notifications_controller"
import DropdownController from "./dropdown_controller"
import SidebarController from "./sidebar_controller"
import TagInputController from "./tag_input_controller"
import NestedFormController from "./nested_form_controller"
import PersonaWizardController from "./persona_wizard_controller"
import CompanyCreationController from "./company_creation_controller"
import CompanyEnrichmentController from "./company_enrichment_controller"
import ApolloEnrichmentController from "./apollo_enrichment_controller"
import BackgroundJobController from "./background_job_controller"
import BlogScanController from "./blog_scan_controller"
import ChatWidgetController from "./chat_widget_controller"
import BulkSelectionController from "./bulk_selection_controller"
import CompetitiveIntelligenceController from "./competitive_intelligence_controller"
import GlobalSearchController from "./global_search_controller"
import BackgroundTaskController from "./background_task_controller"
import ProspectingBundleController from "./prospecting_bundle_controller"
import ProspectProposalController from "./prospect_proposal_controller"
import FeedbackWidgetController from "./feedback_widget_controller"
import JanusPreviewController from "./janus_preview_controller"
import ContentBlockController from "./content_block_controller"
import RegenerateBlockModalController from "./regenerate_block_modal_controller"
import PortfolioKickoffModalController from "./portfolio_kickoff_modal_controller"
import DocumentationNavController from "./documentation_nav_controller"

// Register all controllers
application.register("hello", HelloController)
application.register("notifications", NotificationsController)
application.register("dropdown", DropdownController)
application.register("sidebar", SidebarController)
application.register("tag-input", TagInputController)
application.register("nested-form", NestedFormController)
application.register("persona-wizard", PersonaWizardController)
application.register("company-creation", CompanyCreationController)
application.register("company-enrichment", CompanyEnrichmentController)
application.register("apollo-enrichment", ApolloEnrichmentController)
application.register("background-job", BackgroundJobController)
application.register("blog-scan", BlogScanController)
application.register("chat-widget", ChatWidgetController)

application.register("bulk-selection", BulkSelectionController)
application.register("competitive-intelligence", CompetitiveIntelligenceController)
application.register("global-search", GlobalSearchController)
application.register("background-task", BackgroundTaskController)
application.register("prospecting-bundle", ProspectingBundleController)
application.register("prospect-proposal", ProspectProposalController)
application.register("feedback-widget", FeedbackWidgetController)
application.register("janus-preview", JanusPreviewController)
application.register("content-block", ContentBlockController)
application.register("regenerate-block-modal", RegenerateBlockModalController)
application.register("portfolio-kickoff-modal", PortfolioKickoffModalController)
application.register("documentation-nav", DocumentationNavController)
